import { LeftSidebarView, ViewBody } from 'components/Sidebar'
import React, { useEffect, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import {
  FormGroup,
} from 'react-bootstrap'
import KanBoIcon from 'components/KanBoIcon'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { ModalBoardContext } from 'components/Modal'
import { useBoardContext } from 'dataProviders/Board'
import requestAddDocumentTemplate from '../sagas/requestAddDocumentTemplate'
import requestRemoveDocumentTemplate from '../sagas/requestRemoveDocumentTemplate'
import useGetData from 'hooks/useGetData'
import DocumentTemplateItem from './DocumentTemplateItem'
import Alert from 'components/Alert'
import Loader from 'components/Loader'
import DocumentTemplateSettingsSelector from './DocumentTemplateSettingsSelector'

const SelectedDocumentTemplates: React.FC<LeftSidebarProps & {
  documentListId: number;
}> = ({
  leftSidebar,
  documentListId,
}) => {
  const boardContext = useBoardContext()

  const dispatch = useDispatch()

  const name = useSelector<any, string>(state => state['view-card'].elements.elementsById[documentListId].name)

  const [Items, setItems] = useState<any>()

  const documentListSettingsArgs = useMemo(() => ({
    documentsContainerId: documentListId
  }), [documentListId])
  const {
    data: SelectedDocumentTemplates,
    fetch,
  }: {
    data: any,
    fetch: () => void
  } = useGetData('SelectedDocumentTemplates', documentListSettingsArgs)

  useEffect(() => {
    if (SelectedDocumentTemplates) {
      setItems(SelectedDocumentTemplates.Items)
    }
  }, [SelectedDocumentTemplates])

  const handleAddClick = () => {
    leftSidebar.push(() =>
      <ModalBoardContext boardId={boardContext.id}>
        <DocumentTemplateSettingsSelector
          onAdd={async (items) => {

            if (items.length > 0) {
              await Promise.all(items.map(item =>
                dispatch(requestAddDocumentTemplate({
                  documentListId,
                  template: item,
                }))
              ))
            }

            fetch()
          }}
        />
      </ModalBoardContext>
    )
  }

  return (
    <LeftSidebarView
      title={<FormattedMessage id='DOCUMENT_LIST_SETTINGS_ALLOWED_DOCUMENT_TEMPLATES' />}
      subtitle={name}
      buttons={[{
        icon: <KanBoIcon fixedWidth name='kanbo-16-plus' />,
        title: <FormattedMessage id='ADD' />,
        onClick: handleAddClick
      }]}
    >
      <FormGroup>
        {Items?.length === 0 && (
          <ViewBody>
            <Alert>
              <FormattedMessage id='DOCUMENT_LIST_SETTINGS_ALLOWED_DOCUMENT_TEMPLATES_NO_ALLOWED_DOCUMENT_TEMPLATES' />
            </Alert>
          </ViewBody>
        )}
        {!Items && <Loader center />}
        <ul className='list-group'>
          {Items?.map((AllowedDocumentTemplate, index) =>
            <DocumentTemplateItem
              key={`${AllowedDocumentTemplate.DocumentTemplateSourceId}${AllowedDocumentTemplate.Identifier ? `-${AllowedDocumentTemplate.Identifier}` : ''}`}
              type={AllowedDocumentTemplate.Type}
              documentTemplateSourceId={AllowedDocumentTemplate.DocumentTemplateSourceId}
              identifier={AllowedDocumentTemplate.Identifier}
              name={AllowedDocumentTemplate.Name}
              onRemove={async () => {
                setItems([
                  ...Items.slice(0, index),
                  ...Items.slice(index + 1)
                ])

                await dispatch(requestRemoveDocumentTemplate({
                  documentListId,
                  documentTemplateSourceId: AllowedDocumentTemplate.DocumentTemplateSourceId,
                  identifier: AllowedDocumentTemplate.Identifier,
                }))

                fetch()
              }}
            />
          )}
        </ul>
      </FormGroup>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(SelectedDocumentTemplates)
